import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../Components/Header/Header.js";
import { apiCallExpieredPlanHistory } from "../../Core/Apicall.js";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions.js";
import EmptyData from "../../Components/EmptyData/EmptyData.js";
import ExpieredHistoryList from "../../Components/Memberships/ExpieredHistoryList.js";
import CustomDropdown from "../../Components/DropDown/CustomDropdown.js";
import CustomPagination from "../../Components/CustomPagination/CustomPagination.js";

const History = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const [data, setData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const statusDropdownItem = ['All', 'Active', 'Cancelled', 'Expired'];
  const dateDropdownItem = ['All Time', 'Today', 'This Week', 'This Month', 'Last 6 Months'];
  const typeDropdownItem = ['All', 'Pro', 'Ambassador'];
  const [statusSelect, setStatusSelect] = useState('All');
  const [dateFilter, setDateFilter] = useState("All Time");
  const [typeFilter, setTypeFilter] = useState("All");
  const [initialPage, setInitialPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const fetchApiData = async (
    selectedPage = initialPage,
    statusParam = statusSelect,
    typeParam = typeFilter,
    dateParam = dateFilter
  ) => {
    try {
      dispatch(setLoadingTrue());
      const params = {
        offset: selectedPage + 1,
        limit: 10,
        status: statusParam.toUpperCase(),
        planType: typeParam.toUpperCase(),
        dateFilter: dateParam,
      };
      const response = await apiCallExpieredPlanHistory(params);
      setTotalCount(response?.totalCount ?? 0);
      setInitialPage(selectedPage ?? 0);
      setData(response.data || []);
      dispatch(setLoadingFalse());
    } catch (error) {
      console.error("Error fetching history list:", error);
      dispatch(setLoadingFalse());
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  useEffect(() => {
    fetchApiData(0);
  }, []);

  return (
    <div>
      <div className='astrologers-list-parent padding-top-bottom'>
        <div className='custom-box-user'>
          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={typeFilter}
              items={typeDropdownItem}
              color='blue'
              onSelect={(value) => {
                setTypeFilter(value);
                fetchApiData(0, statusSelect, value, dateFilter);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>

          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={statusSelect}
              items={statusDropdownItem}
              color='blue'
              onSelect={(value) => {
                setStatusSelect(value);
                fetchApiData(0, value, typeFilter, dateFilter);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>

          <div className='custom-container-dropdown-div'>
            <CustomDropdown
              dropDownLabel={dateFilter}
              items={dateDropdownItem}
              color='blue'
              onSelect={(value) => {
                setDateFilter(value);
                fetchApiData(0, statusSelect, typeFilter, value);
              }}
              customLabelStyle={{
                fontWeight: '400',
                color: 'white'
              }}
            />
          </div>
        </div>
      </div>

      <div className="Event-custom-style">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">
            Subscription History
          </div>
          <div className="transparentWhite">
            <nav className="grid-cols grid_7 fontSize16WithoutFlex transparentWhite-padding">
              <div style={{ width: "24%" }} className="user_name">
                User
              </div>
              <div style={{ width: "20%" }} className="user_name">
                Plan
              </div>
              <div style={{ width: "18%" }} className="user_name">
                Upgraded Details
              </div>
              <div style={{ width: "15%" }} className="user_name">
                Status
              </div>
              <div style={{ width: "23%" }} className="user_name">
                Date
              </div>
            </nav>

            <ExpieredHistoryList data={data} />
          </div>
        </div>
      </div>

      {data?.length === 0 && !isLoading && (
        <div className="empty-centered">
          <EmptyData />
        </div>
      )}

      {data?.length !== 0 && (
        <div className='Custom-Pagination'>
          <CustomPagination
            pageCount={Math.ceil(totalCount / 10)}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              fetchApiData(selected);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default History;